function cloneEvent(event, overrides) {
  const Constructor = event.constructor;
  const initObj = Object.assign({}, event, overrides);

  return new Constructor(event.type, initObj);
}


export default cloneEvent;
